module.exports = __webpack_public_path__ + "img/base.76dbfef6.png";